import { Dropdown as DSDropdown } from "@packages/ds";

// Import local wrapper components
import CheckboxItemComponent from "./CheckboxItem";
import CommandMenuComponent from "./CommandMenu";
import ItemComponent from "./Item";
import LinkItemComponent from "./LinkItem";
import RadioItemComponent from "./RadioItem";
import RootComponent from "./Root";

// Create the namespaced component with both wrapped and directly re-exported components
export const Dropdown = {
  Root: RootComponent,
  Item: ItemComponent,
  Trigger: DSDropdown.Trigger,
  Chevron: DSDropdown.Chevron,
  Image: DSDropdown.Image,
  TriggerContent: DSDropdown.TriggerContent,
  TriggerLabel: DSDropdown.TriggerLabel,
  TriggerName: DSDropdown.TriggerName,
  Content: DSDropdown.Content,
  Label: DSDropdown.Label,
  Separator: DSDropdown.Separator,
  FlatItem: DSDropdown.FlatItem,
  ItemLabel: DSDropdown.ItemLabel,
  CheckboxItem: CheckboxItemComponent,
  RadioItem: RadioItemComponent,
  LinkItem: LinkItemComponent,
  CommandMenu: CommandMenuComponent,
  Portal: DSDropdown.Portal
};

// Default export for backward compatibility
export default Dropdown;

// Named exports for backward compatibility with namespace imports
export const Root = RootComponent;
export const Item = ItemComponent;
export const Trigger = DSDropdown.Trigger;
export const Chevron = DSDropdown.Chevron;
export const Image = DSDropdown.Image;
export const TriggerContent = DSDropdown.TriggerContent;
export const TriggerLabel = DSDropdown.TriggerLabel;
export const TriggerName = DSDropdown.TriggerName;
export const Content = DSDropdown.Content;
export const Label = DSDropdown.Label;
export const Separator = DSDropdown.Separator;
export const FlatItem = DSDropdown.FlatItem;
export const ItemLabel = DSDropdown.ItemLabel;
export const CheckboxItem = CheckboxItemComponent;
export const RadioItem = RadioItemComponent;
export const LinkItem = LinkItemComponent;
export const CommandMenu = CommandMenuComponent;
export const Portal = DSDropdown.Portal;

// Re-export types from the design system
export type {
  DropdownRootProps,
  DropdownTriggerProps,
  DropdownContentProps,
  DropdownItemProps,
  DropdownLinkItemProps,
  DropdownCheckboxItemProps,
  DropdownRadioItemProps,
  DropdownCommandMenuProps,
  DropdownTriggerContentProps,
  DropdownFlatItemProps
} from "@packages/ds";
